



import { Component, Vue, Prop } from "vue-property-decorator";
import { ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";
import ParticaList2Line from "../../Common/List/ParticaList2LineV3.vue";
import { ParticaListContent } from "../../../Models/ParticaListModel";

@Component({
	name: "IssuesList",
	components: { ParticaList2Line }
})
export default class IssuesList extends Vue {
	@Prop() private data: ParticaListContent;
	@Prop() private buttons: ButtonConfig[];

	private eventHandler(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}
}
